// extracted by mini-css-extract-plugin
export default {"custom_close_button":"styles_custom_close_button__OZ78Q"};